// Global error handler for better error tracking
export const setupGlobalErrorHandlers = () => {
  // Handle unhandled promise rejections
  window.addEventListener('unhandledrejection', (event) => {
    console.error('🚨 Unhandled Promise Rejection:', {
      reason: event.reason,
      promise: event.promise,
      timestamp: new Date().toISOString(),
      url: window.location.href,
      userAgent: navigator.userAgent
    });
    
    // Prevent the default browser behavior
    event.preventDefault();
  });

  // Handle uncaught errors
  window.addEventListener('error', (event) => {
    console.error('🚨 Uncaught Error:', {
      message: event.message,
      filename: event.filename,
      lineno: event.lineno,
      colno: event.colno,
      error: event.error,
      timestamp: new Date().toISOString(),
      url: window.location.href,
      userAgent: navigator.userAgent
    });
  });

  // Handle React errors that escape error boundaries
  const originalConsoleError = console.error;
  console.error = (...args) => {
    // Check if this is a React error
    if (args[0] && typeof args[0] === 'string' && args[0].includes('React')) {
      // Use originalConsoleError to avoid recursion
      originalConsoleError('🚨 React Error Detected:', {
        message: args[0],
        stack: args[1],
        timestamp: new Date().toISOString(),
        url: window.location.href,
        userAgent: navigator.userAgent
      });
    }
    
    // Call original console.error
    originalConsoleError.apply(console, args);
  };
};

// Parse stack trace to get meaningful information
export const parseStackTrace = (stack: string) => {
  if (!stack) return null;
  
  const lines = stack.split('\n');
  const parsed = lines.map(line => {
    // Match patterns like: at functionName (file.js:line:column)
    const match = line.match(/at\s+(.+?)\s+\((.+?):(\d+):(\d+)\)/);
    if (match) {
      return {
        function: match[1],
        file: match[2],
        line: parseInt(match[3]),
        column: parseInt(match[4])
      };
    }
    
    // Match patterns like: at file.js:line:column
    const simpleMatch = line.match(/at\s+(.+?):(\d+):(\d+)/);
    if (simpleMatch) {
      return {
        function: 'anonymous',
        file: simpleMatch[1],
        line: parseInt(simpleMatch[2]),
        column: parseInt(simpleMatch[3])
      };
    }
    
    return { raw: line };
  });
  
  return parsed;
};
